<script>
import Modal from '@maison/components/common/Modal.vue';
import modalMixin from '@phoenix/mixins/modalMixin';

export default {
  components: {
    Modal,
  },

  mixins: [modalMixin],

  props: {
    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>

<template>
  <modal :id="id" :title="title" naked>
    <template #content>
      <slot name="content" />
    </template>

    <template v-if="hasFooterSlot" #footer>
      <slot name="footer" />
    </template>
  </modal>
</template>
